<div class="tools-container" [formGroup]="toolsFormGroup">
  <h4 class="tools-title">{{ 'PRESENTER.TOTAL_RAISED_TOOLS.TITLE' | translate }}</h4>

  <mat-form-field>
    <mat-label>{{ 'PRESENTER.TOTAL_RAISED_TOOLS.LABEL' | translate }}</mat-label>
    <input matInput [formControl]="labelControl" />
  </mat-form-field>

  <mat-slide-toggle [formControl]="trackBidsControl">
    {{ 'PRESENTER.TOTAL_RAISED_TOOLS.TRACK_BIDS' | translate }}
  </mat-slide-toggle>
  <mat-slide-toggle [formControl]="trackDonationsControl">
    {{ 'PRESENTER.TOTAL_RAISED_TOOLS.TRACK_DONATIONS' | translate }}
  </mat-slide-toggle>
  <mat-slide-toggle [formControl]="trackPurchasesControl">
    {{ 'PRESENTER.TOTAL_RAISED_TOOLS.TRACK_PURCHASES' | translate }}
  </mat-slide-toggle>
  <mat-slide-toggle [formControl]="trackRafflesControl">
    {{ 'PRESENTER.TOTAL_RAISED_TOOLS.TRACK_RAFFLES' | translate }}
  </mat-slide-toggle>
  <mat-slide-toggle [formControl]="trackTicketSalesControl">
    {{ 'PRESENTER.TOTAL_RAISED_TOOLS.TRACK_TICKET_SALES' | translate }}
  </mat-slide-toggle>
  <mat-slide-toggle [formControl]="baseTotalRaisedEnabledControl">
    {{ 'PRESENTER.TOTAL_RAISED_TOOLS.BASE_TOTAL_RAISED_ENABLED' | translate }}
  </mat-slide-toggle>

  <gb-presenter-tools-text [toolsFormGroup]="toolsFormGroup" [hideFields]="hideFields"></gb-presenter-tools-text>

  @if (!isTemplateMode) {
    <button mat-stroked-button type="button" class="filter-teams-button" (click)="openFilterItemsDialog()">
      <span class="button-inner">
        <gb-icon icon="filter" height="18px"></gb-icon>
        <span>{{ 'PRESENTER.ITEM_TABLE_TOOLS.FILTER_ITEMS.BUTTON' | translate }}</span>
      </span>
    </button>

    @if (excludedItemsCount > 0) {
      <button type="button" class="excluded-items-link" (click)="openExcludedItemsDialog()">
        {{
          (excludedItemsCount === 1
            ? 'PRESENTER.ITEM_TABLE_TOOLS.EXCLUDED_ITEMS.COUNT_SINGULAR'
            : 'PRESENTER.ITEM_TABLE_TOOLS.EXCLUDED_ITEMS.COUNT'
          ) | translate: { count: excludedItemsCount }
        }}
      </button>
    }
  }
</div>
